import view from "../../views/toolbar.js";
import KTAPI from "../api/index.api.js";
import { _user, _handler,  } from "../classes/index.classes";
import { router } from "../router/index.routes";
import { ioSocket } from "../mm/index.mm";

let countUps = {};

let toolbar = {
    render: () => {
        console.log('render toolbar');
        return view;
    },
    after_render: async () => {
        //const token = KTCookie.get("token");                
        if(!_user.authed)
        {  
            
        }
        else
        {
            
        }

        let data = await KTAPI.getToolbarData();
        renderToolbarData(data);

        setTimeout(async () => {
            renderToolbarData(await KTAPI.getToolbarData());
        }, 3000);
        
        setInterval(async () => {
            renderToolbarData(await KTAPI.getToolbarData());
        }, 2 * 60 * 1000);

        await router.updatePageLinks();

        
    },
    root: false, 
    rerender: true,
    rendered: false,
    where: '#kt_toolbar',
};

$(document).ready(function(){    

});

_handler.on('update-user', async (data) => {
    //console.log("Update User", data);
    
});

function renderToolbarData(data)
{
    if(data !== undefined)
    {
        if(data.online) $(".num-online-users").text(data.online);
        if($(".toolbar-data").html().length == 0) 
        {
            let html = `
                <div class="d-flex align-items-center flex-wrap d-grid gap-2 ">
                    <!--begin::Item-->                  
                    <div class="d-flex align-items-center me-5 me-xl-13">
                        <!--begin::Symbol-->
                        <div class="symbol symbol-30px me-3">                                                   
                            <span class="symbol-label" style="background: rgba(255, 255, 255, 0.05);"><i class="fad fa-user-tie fs-4 text-primary"></i></span>
                        </div>
                        <!--end::Symbol--> 
                
                        <!--begin::Info-->
                        <div class="m-0">                               
                            <span class="text-gray-600 text-opacity-75 fs-8">Online</span>
                            <span class="fw-bold text-gray-900 fs-7 d-block" id="users-online">0</span>
                        </div>
                        <!--end::Info-->
                    </div>                    
                    <!--end::Item-->
                    <!--begin::Item-->                  
                    <div class="d-flex align-items-center me-5 me-xl-13">
                        <!--begin::Symbol-->
                        <div class="symbol symbol-30px me-3">                                                   
                            <span class="symbol-label" style="background: rgba(255, 255, 255, 0.05);"><i class="fad fa-user-secret fs-4 text-primary"></i></span>
                        </div>
                        <!--end::Symbol--> 
                
                        <!--begin::Info-->
                        <div class="m-0">                               
                            <span class="text-gray-600 text-opacity-75 fs-8">Guests</span>
                            <span class="fw-bold text-gray-900 fs-7 d-block" id="guests-online">0</span>
                        </div>
                        <!--end::Info-->
                    </div>                    
                    <!--end::Item-->
                    <!--begin::Item-->                  
                    <div class="d-flex align-items-center me-5 me-xl-13">
                        <!--begin::Symbol-->
                        <div class="symbol symbol-30px me-3">                                                   
                            <span class="symbol-label" style="background: rgba(255, 255, 255, 0.05);"><i class="fad fa-swords fs-4 text-primary"></i></span>
                        </div>
                        <!--end::Symbol--> 
                
                        <!--begin::Info-->
                        <div class="m-0">                               
                            <span class="text-gray-600 text-opacity-75 fs-8">Total Matches</span>
                            <span class="fw-bold text-gray-900 fs-7 d-block" id="total-matches">0</span>
                        </div>
                        <!--end::Info-->
                    </div>                    
                    <!--end::Item-->
                    <!--begin::Item-->                  
                    <div class="d-flex align-items-center me-5 me-xl-13">
                        <!--begin::Symbol-->
                        <div class="symbol symbol-30px me-3">                                                   
                            <span class="symbol-label" style="background: rgba(255, 255, 255, 0.05);"><i class="fad fa-users fs-4 text-primary"></i></span>
                        </div>
                        <!--end::Symbol--> 
                
                        <!--begin::Info-->
                        <div class="m-0">                               
                            <span class="text-gray-600 text-opacity-75 fs-8">Total Users</span>
                            <span class="fw-bold text-gray-900 fs-7 d-block" id="total-users">0</span>
                        </div>
                        <!--end::Info-->
                    </div>                    
                    <!--end::Item-->
                </div>
            `;

            html = $(html);
            $(".toolbar-data").html(html);

            let options = {
                startVal: 0,
            };
            countUps.online = new countUp.CountUp("users-online", data.online, options);
            countUps.guests = new countUp.CountUp("guests-online", data.guests, options);
            countUps.totalMatches = new countUp.CountUp("total-matches", data.totalMatches, options);
            countUps.totalUsers = new countUp.CountUp("total-users", data.totalUsers, options);

        }
        else
        {
            
            if(data.online !== undefined && countUps.online !== undefined) countUps.online.update(data.online);
            if(data.guests !== undefined && countUps.guests !== undefined) countUps.guests.update(data.guests);
            if(data.totalMatches !== undefined && countUps.totalMatches !== undefined) countUps.totalMatches.update(data.totalMatches);
            if(data.totalUsers !== undefined && countUps.totalUsers !== undefined) countUps.totalUsers.update(data.totalUsers);
            
        }
    }
}


/**
 * 
 * SOCKET.IO PROCESSES
 * 
 */


const toolbarSocket = (socket) => {
    socket.on("update-toolbar", async (data) => {
        
        if(data === undefined) return;
        if(data.data === undefined) return;
        renderToolbarData(data.data);
    });
};
export {toolbarSocket};
export default toolbar;